import { Component } from '@angular/core';

@Component({
	selector: 'cmv-error-message',
	templateUrl: './error-message.component.html',
	styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent {
	constructor() {}
}
